import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import ChooseClientTypeDialogForChip from "./ChooseClientTypeDialogForChip"
interface IProps {
	label?: string
	maxWidth?: number
	disabled?: boolean
	selectedClientType?: string
	handleSave(clientType: string): void
}
interface IState {
	selectedClientType: string
	openChooseDialog: boolean
}

export default class ChooseClientTypeChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedClientType: props.selectedClientType,
			openChooseDialog: false,
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedClientType: nextProps.selectedClientType })
	}

	render() {
		return (
			<div>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{this.props.disabled && !this.props.selectedClientType ?
						null :
						this.props.label ?
							this.props.label :
							strings.Client_Type
					}
				</div>
				{this.state.selectedClientType &&
					<Chip
						style={{ margin: 2, height: 35, width: "min-content" }}
						onRequestDelete={this.props.disabled ?
							null :
							() => {
								this.setState({ selectedClientType: null })
								this.props.handleSave(null)
							}
						}
					>
						<div
							className="TextOverflow"
							title={this.state.selectedClientType}
							style={{ maxWidth: this.props.maxWidth ? this.props.disabled ? this.props.maxWidth : this.props.maxWidth - 25 : 150 }}
						>
							{this.state.selectedClientType}
						</div>
					</Chip>
				}
				{!this.props.disabled && !this.state.selectedClientType &&
					<IconButton
						style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
						onTouchTap={() => this.setState({ openChooseDialog: true })}
					>
						<FontIcon className="fa fa-plus-circle" />
					</IconButton>
				}
				{this.state.openChooseDialog &&
					<ChooseClientTypeDialogForChip
						handleClose={() => this.setState({ openChooseDialog: false })}
						handleSave={selectedClientType => {
							this.setState({
								selectedClientType,
								openChooseDialog: false
							})
							this.props.handleSave(selectedClientType)
						}}
					/>
				}
			</div>
		)
	}
}
